import { useState } from "react";
import FadeUp from "component/FadeUp/FadeUp";
import accordionPlus from "../../assets/images/accordion/accordionPlus.svg";
import accordionMinus from "../../assets/images/accordion/accordionMinus.svg";

import "./accordion.scss";

const data = [
  {
    title: "When will the product get shipped?",
    content: "The Product will be shipped in 10 to 12 Business days",
    subContent: []
  },
  {
    title: "Is Neo 1 compatible with both iOS and Android?",
    content:
      "Yes, Neo 1 is compatible with both iOS and Android devices. You can download the NeoSapien app from the Google Play or App Store.",
    subContent: []
  },
  {
    title: "How secure is my data on Neo 1?",
    content:
      "Your data is end-to-end encrypted and securely stored on our cloud, ensuring maximum privacy and protection. Audio files are not stored once processed. Neo 1 is audited by 3rd party security agencies to ensure that all information is 100% secure and private.",
    subContent: []
  },
  {
    title: "Does Neo 1 record and store all my conversations?",
    content:
      "No, Neo 1 only uses the audio file to transcribe information. It does not store any audio recordings. You can also delete any of these transcriptions from the app and they will be removed from all our servers.",
    subContent: []
  },
  {
    title: "Can I use Neo 1 without an internet connection?",
    content:
      "Neo 1 requires your phone to be connected to the internet via mobile network or Wi-Fi to function. It will not work without an internet connection.  ",
    subContent: []
  },
  {
    title: "Is Neo 1 water-resistant?",
    content:
      "No, Neo 1 is not water-resistant. If it comes into contact with water, ensure you dry it immediately.",
    subContent: []
  },
  {
    title: "Will I receive a chain with this?",
    content: "Yes, a metal chain is included with Neo 1.",
    subContent: []
  },
  {
    title: "How long does the battery last?",
    content: "The battery lasts up to 2 days, depending on usage.",
    subContent: []
  },
  {
    title: "Do you ship internationally?",
    content: "Currently, we do not offer international shipping.",
    subContent: []
  }
];

const Accordion = () => {
  const [active, setActive] = useState(-1);
  const [headerActive, setHeaderActive] = useState(-1);

  const handleActive = (index) => {
    if (active === index) {
      setActive(-1);
    } else {
      setActive(-1);

      setTimeout(() => {
        setActive(index);
      }, 300);
    }

    if (index === headerActive) {
      setTimeout(() => {
        setHeaderActive(-1);
      }, 400);
    } else {
      setTimeout(() => {
        setHeaderActive(index);
      }, 400);
    }
  };

  return (
    <>
      <section className="container faq">
        <div className="common-heading">
          <FadeUp>
            <h1>Frequently Asked Questions</h1>
          </FadeUp>
        </div>
        <div className="accordionWidth">
          <div className="accordionSection">
            {data?.map((item, index) => (
              <div className="accordionContainer" key={index}>
                <div
                  className={
                    headerActive === index ? "display activeDisplay" : "display"
                  }
                  onClick={() => handleActive(index)}
                >
                  <div className="question">
                    <p>{item.title}</p>
                  </div>
                  <div className="imgSection">
                    <div className="plusWrapper">
                      {headerActive === index ? (
                        <img
                          className="accordion-icon"
                          src={accordionMinus}
                          alt=""
                        />
                      ) : (
                        <img
                          className="accordion-icon"
                          src={accordionPlus}
                          alt=""
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className={
                    active === index
                      ? "accordionContent active"
                      : "accordionContent"
                  }
                  style={{
                    maxHeight: active === index && "500px"
                  }}
                >
                  <div
                    className="contentText"
                    style={{
                      background: "$color-white-0"
                    }}
                  >
                    <p className="contentP">{item.content}</p>

                    <ul>
                      {item.subContent?.map((subItem, index) => (
                        <li style={{ listStyleType: "square" }} key={index}>
                          {subItem}
                        </li>
                      ))}
                    </ul>
                  </div>
                  {/* <p
                    className="contentText"
                    style={{
                      background: "$color-white-0"
                    }}
                  >
                    {item.content}
                  </p> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Accordion;
